import axios from "axios";

export default {
   getSchedule() {
      return axios.get("/class-schedule").then((response) => {
         return response.data;
      });
   },
   getScheduleDataSource(params) {
      return axios
         .get("/class-schedule/datasource", { params })
         .then((response) => {
            return response.data;
         });
   },
   getSchedulebyID(id) {
      return axios.get("/class-schedule/" + id).then((response) => {
         return response.data;
      });
   },
   createSchedule(formdata) {
      return axios.post("/class-schedule", formdata).then((response) => {
         return response.data;
      });
   },
   updateSchedule(id, formdata) {
      return axios.post("/class-schedule/" + id, formdata).then((response) => {
         return response.data;
      });
   },
   deactivateSchedule(id) {
      return axios
         .put("/class-schedule/" + id + "/deactivate")
         .then((response) => {
            return response.data;
         });
   },
   reactivateSchedule(id) {
      return axios
         .put("/class-schedule/" + id + "/reactivate")
         .then((response) => {
            return response.data;
         });
   },
   destroySchedule(id) {
      return axios
         .delete("/class-schedule/" + id + "/delete")
         .then((response) => {
            return response.data;
         });
   },
   getParticipantDataSource(params) {
      return axios
         .get("/class-participant/datasource", { params })
         .then((response) => {
            return response.data;
         });
   },
   getParticipantbyID(id) {
      return axios
         .get("/class-participant/detail?people_id=" + id)
         .then((response) => {
            return response.data;
         });
   },
   getGraduate(params) {
      return axios.get("/class-participant/list-graduate").then((response) => {
         return response.data;
      });
   },
   setAttend(formdata) {
      return axios
         .post("/class-participant/attend", formdata)
         .then((response) => {
            return response.data;
         });
   },
   setGraduate(formdata) {
      return axios
         .post("/class-participant/graduate", formdata)
         .then((response) => {
            return response.data;
         });
   },
   setPublish(id,formdata){
      return axios.post("/class-schedule/" + id + "/status",formdata )
          .then(response => {
              return response.data
          })
  }, 
  getTeacher() {
   return axios.get("/class-teacher/get").then((response) => {
      return response.data;
      });
   },
   getClassTeacher(params) {
      return axios
         .get("/class-teacher/assign", { params })
         .then((response) => {
            return response.data;
         });
   },
   assignClassTeacher(formdata){
      return axios.post('/class-teacher/insert', formdata)
          .then(response => {
              return response.data
          })
  },
  deleteClassTeacher(formdata){
   return axios.post('/class-teacher/delete', formdata)
       .then(response => {
           return response.data
       })
},
   
};
